import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.css']
})
export class MaintenanceComponent {

  env = environment;
  currentYear:any;

  constructor(
    private router: Router
  ){}

  ngOnInit(){
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();

  }

  toHome(){
    this.router.navigate(['/']);
  }
}
